/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';

import {PERMISSIONS} from '../../../components/auth/auth-constants';
import {EmailTemplateResource} from '../../../components/api/resources/resource/email-template.resource';
import {LocalUserPermissions} from '../../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-email-template-route-page',
  template: `
    <adn-email-template-list-page
      *ngIf="list"
      [list]="list">
    </adn-email-template-list-page>
  `
})
export class EmailTemplateRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(EmailTemplateResource) private readonly EmailTemplate: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

  ngOnInit(): void {
    const readOnly = !this.LocalUserPermissions.hasNetwork(PERMISSIONS.manageSystem.apiKey)
      && !this.LocalUserPermissions.hasDataNetworkPermission(PERMISSIONS.dataAdmin.apiKey)
      && !this.LocalUserPermissions.hasNetworkPermission(PERMISSIONS.politicalAdmin.apiKey, null, 'POLITICAL');

    this.adnListHelper.setUpList(this.list, this.EmailTemplate, readOnly, 'fullEmailTemplateList', {
      baseTable: 'emailTemplate'
    });
  }
}
